import { RESEARCH_ELECTRONIC_SIGNATURES_ERRORS } from '@/config/research';
import { PipelineEvents } from './PipelineEvents';

export const ProjectPipelines = {
  namespaced: true,

  modules: {
    events: PipelineEvents,
  },

  state: {
    viewMode: true,
    current: {
      design: null,
      live: null,
    },
    loading: false,
    saving: false,
    loadedLivePipeline: false,
    diff: {},
    pipelineViewDebounceTrigger: new Date(),
    pipelineNotSignedCurrentVersion: null,
    eSignatureError: null,
    isSignPipelineSuccessful: false,
  },

  getters: {
    pipelineViewDebounceTrigger: (state) => state.pipelineViewDebounceTrigger,

    getCurrentDesignPipeline: (state) => state.current?.design,

    loadedLivePipeline: (state) => state.loadedLivePipeline,

    getCurrentLivePipeline: (state) => state.current?.live,

    getCurrentPipelineDiff: ({ diff }) => diff ?? {},

    designPipeline: (state) => state.current?.design,

    arePipelinesLoading: (state) => state.loading,

    livePipeline: (state) => state.current?.live,
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },

    setSaving(state, saving) {
      state.saving = saving;
    },

    setCurrentDesignPipeline(state, pipeline) {
      state.current = {
        live: state.current?.live,
        design: pipeline,
      };
    },

    setCurrentLivePipeline(state, pipeline) {
      state.current = {
        live: pipeline,
        design: state.current?.design,
      };
    },

    setCurrentDiff(state, diff) {
      state.diff = diff;
    },

    toggleViewMode(state, viewMode) {
      state.viewMode = viewMode;
    },

    setLoadedLivePipeline(state, bool) {
      Vue.set(state, 'loadedLivePipeline', bool);
    },

    updatePipelineViewDebounceTrigger(state) {
      Vue.set(state, 'pipelineViewDebounceTrigger', new Date());
    },

    setCurrentNotSignedPipelineVersion(state, currentVersion) {
      state.pipelineNotSignedCurrentVersion = currentVersion;
    },

    setESignatureError(state, error) {
      state.eSignatureError = error;
    },

    setIsSignPipelineSuccessful(state, flag) {
      state.isSignPipelineSuccessful = flag;
    },
  },

  actions: {
    async loadCurrentDesignPipeline({ commit }, { project, repository }) {
      if (!project || !repository) {
        return;
      }

      let pipeline = null;

      commit('setLoading', true);
      commit('setCurrentDesignPipeline', null);
      try {
        const response = await this._vm.$api('repositories.projects.pipelines.current', {
          version: '1.0',
          project,
          repository,
          env: 'design',
        });

        pipeline = response.data.data;
      } catch (err) {
        console.error(err);
      }

      commit('setCurrentDesignPipeline', pipeline);
      commit('setLoading', false);
    },

    async loadCurrentLivePipeline({ commit }, { project, repository }) {
      if (!project || !repository) {
        return;
      }

      let pipeline = null;

      commit('setLoading', true);
      commit('setLoadedLivePipeline', false);
      commit('setCurrentLivePipeline', null);
      try {
        const response = await this._vm.$api('repositories.projects.pipelines.current', {
          version: '1.0',
          project,
          repository,
          env: 'live',
        });

        pipeline = response.data.data;
      } catch (err) {
        console.error(err);
      }

      commit('setCurrentLivePipeline', pipeline);
      commit('setLoadedLivePipeline', true);
      commit('setLoading', false);
    },

    async loadPipelineDiff({ commit }, { project, repository }) {
      if (!project || !repository) {
        return;
      }

      let diff = null;

      commit('setSaving', true);
      try {
        const response = await this._vm.$api('repositories.projects.pipelines.current.diff', {
          version: '1.0',
          project,
          repository,
          env: 'design',
        });

        diff = response.data.data;
      } catch (err) {
        console.error(err);
      }

      commit('setCurrentDiff', diff);
      commit('setSaving', false);
    },

    async approvePipeline({ commit, dispatch }, { project, repository, pipeline, data }) {
      commit('setSaving', true);
      commit('setIsSignPipelineSuccessful', false);
      commit('setESignatureError', null);

      let signature = null;

      try {
        await this._vm.$api(
          'repositories.projects.pipelines.e-sign',
          {
            version: '1.0',
            project,
            repository,
            pipeline,
          },
          { ...data }
        );

        commit('setIsSignPipelineSuccessful', true);
      } catch (error) {
        if (error.message === RESEARCH_ELECTRONIC_SIGNATURES_ERRORS.INVALID_SIGNATURE) {
          commit('setESignatureError', RESEARCH_ELECTRONIC_SIGNATURES_ERRORS.INVALID_SIGNATURE);
        } else {
          commit('setESignatureError', RESEARCH_ELECTRONIC_SIGNATURES_ERRORS.GENERIC_ERROR);
        }
        console.error(error);
        commit('setSaving', false);
      }

      commit('toggleViewMode', true);
      commit('setSaving', false);

      if (signature) {
        dispatch('loadCurrentDesignPipeline', { project, repository });
        dispatch('loadCurrentLivePipeline', { project, repository });
      }
    },

    currentNotSignedVersion({ commit }, payloadVersion) {
      commit('setCurrentNotSignedPipelineVersion', payloadVersion);
    },

    resetESignatureError({ commit }) {
      commit('setESignatureError', null);
    },
  },
};
